const trackPaymentInfoEntered = ({orderNumber, cashFund}) => {
  window.analytics.track({
    event: 'Payment Info Entered',
    properties: {
      order_id: orderNumber || null,
      affiliation: cashFund.affiliation,
      checkout_id: orderNumber || null,
      step: 2,
      shipping_method: 'digital',
      payment_method: 'credit',
      wishlist_id: cashFund.memberId || undefined,
    },
  });
};
export default trackPaymentInfoEntered;
